const OPTICS_COMPONENT_ID = '#optic'

$(() => {
  if (!$(OPTICS_COMPONENT_ID).length) return

  new Vue({
    name: 'optic',
    el: OPTICS_COMPONENT_ID,
    data: {
      productCode: $('#productPage .product-details .add-to-basket').data('id'),
      family: $('#productPage #family').val(),
      selectedBundleId: null,
      bundles: [],
      formElements: {
        right: { list: [], validList: [] },
        left: { list: [], validList: [] },
      },
      leftPackages: '',
      rightPackages: '',
      price: 0,
      getPriceOperation: false,
      showValidation: { right: true, left: true },
      formSubmitted: false,
      addedToCart: false,
      maxOrderArray: [null, null],
      outOfStockArray: [null, null],
      notFoundArray: [null, null],
    },
    computed: {
      totalPackages() {
        return (
          (this.rightPackages ? parseInt(this.rightPackages) : 0) +
          (this.leftPackages ? parseInt(this.leftPackages) : 0)
        )
      },
      isInStock() {
        return !this.outOfStockArray[0] && !this.outOfStockArray[1]
          ? true
          : false
      },
      isFound() {
        return !this.notFoundArray[0] && !this.notFoundArray[1] ? true : false
      },
      hasValidFormElements() {
        const {
          right: { validList: validListRight },
          left: { validList: validListLeft },
        } = this.formElements

        return [...validListRight, ...validListLeft].length > 0
      },
    },
    watch: {
      leftPackages() {
        this.getPrice()
      },
      rightPackages() {
        this.getPrice()
      },
    },
    methods: {
      selectBundle(id) {
        this.selectedBundleId = id
        const bundle = this.bundles.filter((x) => x.id == id)[0]
        this.setBundlesPackages(bundle.packages)
      },
      setBundlesPackages(packs) {
        if (!packs) return
        packs = parseInt(packs)
        packs = Number.isNaN(packs) ? 0 : packs
        const singeValue = Math.floor(packs / 2)
        this.leftPackages = singeValue ? singeValue : ''
        this.rightPackages = singeValue ? singeValue : ''
      },
      getFormElements() {
        const form = document.getElementById('opticForm')
        const elements = [...form.elements]

        this.formElements['right'].list = elements.filter((el) =>
          el.name.includes('right')
        )
        this.formElements['left'].list = elements.filter((el) =>
          el.name.includes('left')
        )
      },
      getValidFormElements() {
        const {
          right: { validList: validListRight },
          left: { validList: validListLeft },
        } = this.formElements

        return [...validListRight, ...validListLeft]
      },
      validateFormSide(side) {
        this.formElements[side].validList = []
        let isValid = true
        let isEmpty = true
        this.formElements[side].list.forEach((el) => {
          if (
            el.tagName == 'SELECT' ||
            (el.tagName == 'INPUT' && el.type == 'hidden')
          ) {
            if (
              (!el.value && el.value != 0) ||
              el.parentElement.classList.contains('has-error')
            ) {
              isValid = false
            } else {
              if (el.tagName == 'SELECT') isEmpty = false
              this.formElements[side].validList.push(el)
            }
          }
        })
        if (!isValid) this.formElements[side].validList = []
        return isValid || (!isValid && isEmpty)
      },
      validateForm() {
        setTimeout(
          () => $(this.$el.querySelector('form')).validator('validate'),
          100
        )
        $(this.$el.querySelector('form')).validator('validate')

        const isRightValid = this.validateFormSide('right')
        const isLeftValid = this.validateFormSide('left')

        this.showValidation.right = !isRightValid
        this.showValidation.left = !isLeftValid

        return isRightValid && isLeftValid && this.getValidFormElements().length
      },
      addOpticToCart(e) {
        e.preventDefault()
        this.formSubmitted = true

        if (!this.validateForm()) return

        if (!this.family) {
          genericPop.open({
            title: messageResource['optic.add.item.failed.title'],
            subtitle: messageResource['optic.add.item.failed.description'],
            actionTitle:
              messageResource['text.component.message.general.close'],
          })
          // eslint-disable-next-line no-console
          console.error('no product family')
          return
        }

        const requestData = this.getValidFormElements().reduce(
          (result, formElement) => ({
            ...result,
            [formElement.name]: formElement.value,
          }),
          {}
        )
        requestData.family = this.family
        let updated_price = Number(String(this.price).replace(/\,/g,''))
        SP.optic.addOpticProduct(requestData, updated_price, this.addOpticProductCallback)
      },
      addOpticProductCallback(response) {
        if (!response) return

        if (response.maxOrderQuantity) {
          response.gtMaxOrderQty = null
          this.showMaxOrderPopup(response.maxOrderQuantity)
        } else if (response.outOfStock) {
          this.showOutOfStock(response.outOfStock)
        } else if (response.opticProductNotFound) {
          this.showNotFound(response.opticProductNotFound)
        } else {
          this.resetMaxOrders()
          this.resetOutOfStock()
          this.resetNotFound()
          this.addedToCart = true
          $.publish('cartModelChange', [response, true])
        }
      },
      showMaxOrderPopup(maxOrderArray) {
        if (!maxOrderArray || !maxOrderArray.length) return

        this.maxOrderArray = maxOrderArray.map((element) => {
          if (element || element === 0) {
            return parseInt(element)
          } else {
            return null
          }
        })
        setTimeout(() => this.validateForm())
      },
      showOutOfStock(outOfStockArray) {
        if (!outOfStockArray || !outOfStockArray.length) return
        this.outOfStockArray = outOfStockArray
        setTimeout(() => this.validateForm())
      },
      showNotFound(notFoundArray) {
        if (!notFoundArray || !notFoundArray.length) return
        this.notFoundArray = notFoundArray
        setTimeout(() => this.validateForm())
      },
      getPrice() {
        if (!this.productCode || this.getPriceOperation) return
        this.getPriceOperation = true
        SP.optic.getOpticPrice(
          this.productCode,
          this.totalPackages,
          this.getOpticPriceCallback
        )
      },
      getOpticPriceCallback(response) {
        this.getPriceOperation = false
        this.price = Number(response).toLocaleString(undefined, {
          minimumFractionDigits: 2,
        })
      },
      updateBundles() {
        const bundle =
          this.bundles.filter(
            (x) => parseInt(x.packages) === this.totalPackages
          )[0] || null
        this.selectedBundleId = bundle ? bundle.id : null
      },
      selectChange(row, isPackageSelect) {
        this.addedToCart = false
        this.validateForm()
        this.resetMaxOrders(true)
        if (isPackageSelect) {
          this.updateBundles()
        } else {
          if (
            !this.isInStock &&
            this.outOfStockArray[row === 'right' ? 0 : 1]
          ) {
            this.resetOutOfStock(true)
          }
          if (!this.isFound && this.notFoundArray[row === 'right' ? 0 : 1]) {
            this.resetNotFound(true)
          }
        }
      },
      resetMaxOrders(validate) {
        this.maxOrderArray = [null, null]
        if (validate) {
          setTimeout(() => this.validateForm(), 500)
        }
      },
      resetOutOfStock(validate) {
        this.outOfStockArray = [null, null]
        if (validate) {
          setTimeout(() => this.validateForm(), 500)
        }
      },
      resetNotFound(validate) {
        this.notFoundArray = [null, null]
        if (validate) {
          setTimeout(() => this.validateForm(), 500)
        }
      },
      initValidator() {
        $(this.$el.querySelector('form')).validator({
          custom: {
            max: ($el) => {
              const row = $el.data('max')
              const maxValue = this.maxOrderArray[row === 'right' ? 0 : 1]
              if (maxValue === 0) {
                return messageResource['optics.max.orders.message.zero']
              }
              if (maxValue) {
                return messageResource['optics.max.order.message'].format(
                  maxValue
                )
              }
            },
            outofstock: ($el) => {
              const row = $el.data('outofstock')
              if (this.outOfStockArray[row === 'right' ? 0 : 1]) {
                return messageResource['optic.out.of.stock']
              }
            },
            notfound: ($el) => {
              const row = $el.data('notfound')
              if (this.notFoundArray[row === 'right' ? 0 : 1]) {
                return messageResource['optic.not.found']
              }
            },
          },
          focus: false,
        })
      },
    },
    mounted() {
      this.bundles = [...this.$el.querySelectorAll('.bundle')].map((item) => {
        const bundle = {
          packages: item.dataset.packages,
          id: item.dataset.id,
        }
        if (item.dataset.selected === 'true') {
          this.selectedBundleId = bundle.id
        }

        return bundle
      })
      this.getFormElements()
      this.initValidator()
    },
  })
})
